<template>
    <div>
        <div class="row">
            <member-card :member="member"></member-card>
        </div>
    </div>
</template>

<script>
    import MemberCard from '../../../components/Dashboard/MemberCard'
    export default {
        name: 'Home',
        components: {MemberCard},
        props: ['member']
    }
</script>

<style scoped>

</style>
